export enum GeneralMutationTypes {
  SET_SIDEBAR_STATUS = "SET_SIDEBAR_STATUS",
  SET_FILTER_STATUS = "SET_FILTER_STATUS",
  SET_LOADER_STATUS = "SET_LOADER_STATUS",
  SET_COMPANIES = "SET_COMPANIES",
  SET_SITES = "SET_SITES",
  SET_GROUPS = "SET_GROUPS",
  SET_COMPANY_ASSETS = "SET_COMPANY_ASSETS",
  SET_SETTINGS = "SET_SETTINGS",
  SET_SMTP_SETTINGS = "SET_SMTP_SETTINGS",
  SET_ALERT = "SET_ALERT",
  SET_SELECTED_ROW = "SET_SELECTED_ROW",
  SET_PERMISSION_LEVELS = "SET_PERMISSION_LEVELS",
  SET_REVIEW_STATUSES = "SET_REVIEW_STATUSES",
  SET_RISK_LEVELS = "SET_RISK_LEVELS",
  SET_CREATE_REVIEW = "SET_CREATE_REVIEW",
  SET_SECTIONS = "SET_SECTIONS",
  SET_SCOPE_DETAIL = "SET_SCOPE_DETAIL",
  SET_AGMS_BREADCRUMB_STATUS = "SET_AGMS_BREADCRUMB_STATUS",
  SET_AGMS_BREADCRUMB_DATA = "SET_AGMS_BREADCRUMB_DATA",
  SET_USERS = "SET_USERS",
  SET_PARTNERS = "SET_PARTNERS",
  SET_COMPKEY = "SET_COMPKEY",
  SET_ROW_OPENED = "SET_ROW_OPENED",
  SET_SELECTED_DECISION = "SET_SELECTED_DECISION",
  SET_EXPORT_STATUS = "SET_EXPORT_STATUS",
  SET_EXPORT_DATA_LOADED = "SET_EXPORT_DATA_LOADED",
  SET_ISCREATED_MODAL = "SET_ISCREATED_MODAL",
  SET_SCOPE_MODAL = "SET_SCOPE_MODAL",
  SET_APPGROUPS="SET_APPGROUPS",
  SET_APPGROUPS_PROCESS="SET_APPGROUPS_PROCESS",
  SET_APPGROUPS_FILE_ACCESS ="SET_APPGROUPS_FILE_ACCESS",
  SET_APPGROUPS_REGISTRY_ACCESS="SET_APPGROUPS_REGISTRY_ACCESS",
  SET_APPGROUPS_CODE_LOAD="SET_APPGROUPS_CODE_LOAD",
  SET_APPGROUPS_CHILD_LAUNCH="SET_APPGROUPS_CHILD_LAUNCH",
  SET_GLOBAL_POLICIES="SET_GLOBAL_POLICIES",
  SET_GLOBAL_POLICY_FILE_ACCESS ="SET_GLOBAL_POLICY_FILE_ACCESS",
  SET_GLOBAL_POLICY_REGISTRY_ACCESS ="SET_GLOBAL_POLICY_REGISTRY_ACCESS",
  SET_GLOBAL_POLICY_CODE_LOAD ="SET_GLOBAL_POLICY_CODE_LOAD",
  SET_ENUM="SET_ENUM",
  SET_FOLDER_MAPS = "SET_FOLDER_MAPS",
  SET_PUBLISHER_LIST = "SET_PUBLISHER_LIST",
  SET_APPGROUP_INFO = "SET_APPGROUP_INFO",
  RESET_APP_GROUPS="RESET_APP_GROUPS",
  SET_FILE_TYPES_POLICIES = "SET_FILE_TYPES_POLICIES",
  SET_INHERITANCE_INFO = "SET_INHERITANCE_INFO",
  SET_TEMPLATE_IS_DEFAULT = "SET_TEMPLATE_IS_DEFAULT",
  SET_TEMPLATE_POLICY_IS_DEFAULT = "SET_TEMPLATE_POLICY_IS_DEFAULT",
  SET_REMOVABLE_MEDIA = "SET_REMOVABLE_MEDIA",
  SET_SUMMARY_EVENT_RULES = "SET_SUMMARY_EVENT_RULES",
  SET_SUMMARY_EVENT_INFO = "SET_SUMMARY_EVENT_INFO",
  SET_SUMMARY_EVENT_ENTITY_DATA = "SET_SUMMARY_EVENT_ENTITY_DATA",
}
